import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ContactPage from "../pages/home/ContactPage";
import SEO from "../components/SEO";
import { APP_NAME } from "../helpers/constants";

export default function Contact() {
  const location = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);

  return (
    <Container>
      <SEO
        title={`Contact Us | ${APP_NAME} - Repairs, bids & contractors`}
        description={`Questions about free diagnosis, vetted bid searches, or search fees? Contact ${APP_NAME} for help before you dispatch work.`}
        keywords={`contact ${APP_NAME}, repair bid help, maintenance bid search, vendor outreach, Clumse search fees, Clumse pricing`}
        imageAlt={`Contact ${APP_NAME} for product and pricing questions`}
        category="Repairs & contractor bids"
        url="https://clumse.com/contact"
        canonical="https://clumse.com/contact"
        tags={[
          "contact Clumse",
          "repair bid search",
          "maintenance bid search",
          "Clumse pricing",
        ]}
      />
      <ContactPage />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  /* Page body paints full bleed; matches Home / HomeMain black field */
  background: #000000;
`;
